<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card class="mb-6">
                    <v-card-title class="text-uppercase justify-center">{{ metaData.header }}</v-card-title>
                    <v-card-actions class=" justify-end">
                        <v-btn color="teal" class="white--text" @click="openAddAttributeDialog">
                            {{ $t('add') }} {{ $t('attribute') }}
                        </v-btn>
                        <v-btn color="teal" class="white--text" @click="openEditAttributeDialog">
                            {{ $t('edit') }} {{ $t('attribute') }}
                        </v-btn>
                        <v-btn color="teal" class="white--text" @click="openAddAttributeValueDialog">
                            {{ $t('add') }} {{ $t('attributeValue') }}
                        </v-btn>
                        <v-btn color="teal" class="white--text" :disabled="selectedItems.length === 0"
                            @click="exportToXls">
                            {{ $t('exportXLS') }}
                        </v-btn>
                    </v-card-actions>
                    <v-divider></v-divider>
                </v-card>
                <attributes-filters @filter-change="filterChange" ref="attributeFilters"></attributes-filters>
                <v-card class="mt-6">
                    <attributes-table :filters="filters" @overlay-view="changeOverlay"
                        @load-error="onDataLoadError"></attributes-table>
                </v-card>
            </v-col>
        </v-row>
        <enum-attribute-dialog :is-open="openEnumAttributeDialog" :dialog-type="enumAttributeDialogType"
            @validated="saveAttribute" @deleteAttribute="deleteAttribute"
            @close="openEnumAttributeDialog = false"></enum-attribute-dialog>
        <enum-attribute-value-fullscreen-dialog :is-open="openEnumAttributeValueDialog" :dialog-type="'add'"
            @validated="saveAttributeValue"
            @close="openEnumAttributeValueDialog = false"></enum-attribute-value-fullscreen-dialog>
        <v-snackbar v-model="snackOpen" :color="snackColor" top>
            {{ snackText }}
            <template v-slot:action="{ attrs }">
                <v-btn text icon v-bind="attrs" @click="resetSnack">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <load-overlay :overlay="overlay" :z-index="10"></load-overlay>
    </v-container>
</template>

<script>
import LoadOverlay from "../../../components/overlays/LoadOverlay";
import { AttributesTable } from "../../../components/data-tables";
import { AttributesFilters } from "../../../components/filters";
import { EnumAttributeDialog, EnumAttributeValueDialog, EnumAttributeValueFullscreenDialog } from "../../../components/modals"
import { MixinTableLoadSnack } from '../../../mixins'
import { AttributesService, ExportService } from "../../../services";

export default {
    name: "ReviewAttributes",
    components: {
        AttributesTable,
        AttributesFilters,
        LoadOverlay,
        EnumAttributeDialog,
        EnumAttributeValueDialog,
        EnumAttributeValueFullscreenDialog
    },
    mixins: [MixinTableLoadSnack],
    data() {
        return {
            metaUrl: '/attributes',
            overlay: false,
            filters: {},
            openEnumAttributeDialog: false,
            openEnumAttributeValueDialog: false,
            enumAttributeDialogType: null,
        }
    },
    computed: {
        selectedItems() {
            return this.$store.getters.selectedAttributesValues;
        }
    },
    methods: {
        changeOverlay(data) {
            this.overlay = data;
            if (!data) {
                this.$refs.attributeFilters.getLayout();
            }
        },
        filterChange(filters) {
            this.filters = filters;
        },
        exportToXls() {
            const params = this.selectedItems.map(item => item.id);
            ExportService.attributesValues(params)
            this.$store.commit('setSelectedAttributesValues', []);
        },
        openAddAttributeDialog() {
            this.openEnumAttributeDialog = true;
            this.enumAttributeDialogType = 'add';
        },
        openEditAttributeDialog() {
            this.openEnumAttributeDialog = true;
            this.enumAttributeDialogType = 'edit';
        },
        openAddAttributeValueDialog() {
            this.openEnumAttributeValueDialog = true;
        },
        saveAttribute(data) {
            switch (data.actionType) {
                case 'add': this.createAttribute(data.attributeData); break;
                case 'edit': this.updateAttribute(data.attributeData); break;
                default: return false;
            }
        },
        saveAttributeValue(data) {
            this.createAttributeValue(data)
        },
        createAttribute(data) {
            this.overlay = true;
            this.openEnumAttributeDialog = false;
            AttributesService.setAuth(this.$store.getters.token);
            AttributesService.createAttribute(data)
                .then((res) => {
                    if (res.data.error) {
                        this.setErrorSnack();
                        this.setSnackText(this.$t('addAttributeError'));
                    } else {
                        this.setSuccessSnack();
                        this.setSnackText(this.$t('addAttributeSuccess'));
                    }
                    this.openSnack();
                })
                .catch(err => {
                    this.setErrorSnack();
                    this.snackText = this.$t('addAttributeError');
                    this.openSnack();
                    console.log(err);
                })
                .finally(() => {
                    this.$refs.attributeFilters.getLayout();
                    this.overlay = false;
                });
        },
        updateAttribute(data) {
            this.overlay = true;
            this.openEnumAttributeDialog = false;
            AttributesService.setAuth(this.$store.getters.token);
            AttributesService.updateAttribute(data)
                .then(res => {
                    this.$store.commit('setUpdateAttributesTable', true);
                    this.$store.commit('setUpdateAttributesFilters', true);
                    if (res.data.error) {
                        this.setErrorSnack();
                        this.setSnackText(this.$t('editAttributeError'));
                    } else {
                        this.setSuccessSnack();
                        this.setSnackText(this.$t('editAttributeSuccess'));
                    }
                    this.openSnack();
                    this.$refs.attributeFilters.getLayout();

                })
                .catch(err => {
                    this.setErrorSnack();
                    this.snackText = this.$t('editAttributeError');
                    this.openSnack();
                    console.log(err);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        deleteAttribute(attributeId) {
            this.overlay = true;
            this.openEnumAttributeDialog = false;
            this.resetSnack();
            AttributesService.setAuth(this.$store.getters.token);
            AttributesService.deleteAttribute(attributeId)
                .then(res => {
                    if (res.data) {
                        this.setSuccessSnack();
                        this.setSnackText(this.$t('attributeDeleted'));
                    } else {
                        this.setErrorSnack();
                        this.setSnackText(this.$t('attributeDeleteError'));
                    }
                })
                .catch(err => {
                    this.setSnackText(this.$t('attributeDeleteError'));
                    this.setErrorSnack();
                    console.log(err);
                })
                .finally(() => {
                    this.$refs.attributeFilters.getLayout();
                    this.openSnack();
                    this.overlay = false;
                });
        },
        createAttributeValue(data) {
            this.overlay = true;
            this.openEnumAttributeValueDialog = false;
            AttributesService.setAuth(this.$store.getters.token);
            AttributesService.createAttributeValue(data)
                .then(res => {
                    this.$store.commit('setUpdateAttributesTable', true);
                    this.$store.commit('setUpdateAttributesFilters', true);
                    if (res.data.error) {
                        this.setErrorSnack();
                        this.setSnackText(this.$t('addAttributeValueError'));
                    } else {
                        this.setSuccessSnack();
                        this.setSnackText(this.$t('addAttributeValueSuccess'));
                    }
                    this.openSnack();
                })
                .catch(err => {
                    this.setErrorSnack();
                    this.snackText = this.$t('addAttributeValueError');
                    this.openSnack();
                    console.log(err);
                })
                .finally(() => {
                    this.$refs.attributeFilters.getLayout();
                    this.overlay = false;
                });
        },
    }
}
</script>

<style scoped></style>
